/// <amd-module name="Test/Release/Client/RestClient/Release" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-test-web\release-client\release.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Release from "Test/Release/Client/Contracts/Release";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IReleaseRestClient extends IVssRestClient {
    /**
     * Get a release definition.
     * 
     * @param project - Project ID or project name
     * @param definitionId - Id of the release definition.
     * @param propertyFilters - A comma-delimited list of extended properties to be retrieved. If set, the returned Release Definition will contain values for the specified property Ids (if they exist). If not set, properties will not be included.
     */
    getReleaseDefinition(project: string, definitionId: number, propertyFilters?: string[]): Promise<Release.ReleaseDefinition>;
    /**
     * Get a list of release definitions.
     * 
     * @param project - Project ID or project name
     * @param searchText - Get release definitions with names containing searchText.
     * @param expand - The properties that should be expanded in the list of Release definitions.
     * @param artifactType - Release definitions with given artifactType will be returned. Values can be Build, Jenkins, GitHub, Nuget, Team Build (external), ExternalTFSBuild, Git, TFVC, ExternalTfsXamlBuild.
     * @param artifactSourceId - Release definitions with given artifactSourceId will be returned. e.g. For build it would be \{projectGuid\}:\{BuildDefinitionId\}, for Jenkins it would be \{JenkinsConnectionId\}:\{JenkinsDefinitionId\}, for TfsOnPrem it would be \{TfsOnPremConnectionId\}:\{ProjectName\}:\{TfsOnPremDefinitionId\}. For third-party artifacts e.g. TeamCity, BitBucket you may refer 'uniqueSourceIdentifier' inside vss-extension.json at https://github.com/Microsoft/vsts-rm-extensions/blob/master/Extensions.
     * @param top - Number of release definitions to get.
     * @param continuationToken - Gets the release definitions after the continuation token provided.
     * @param queryOrder - Gets the results in the defined order. Default is 'IdAscending'.
     * @param path - Gets the release definitions under the specified path.
     * @param isExactNameMatch - 'true'to gets the release definitions with exact match as specified in searchText. Default is 'false'.
     * @param tagFilter - A comma-delimited list of tags. Only release definitions with these tags will be returned.
     * @param propertyFilters - A comma-delimited list of extended properties to be retrieved. If set, the returned Release Definitions will contain values for the specified property Ids (if they exist). If not set, properties will not be included. Note that this will not filter out any Release Definition from results irrespective of whether it has property set or not.
     * @param definitionIdFilter - A comma-delimited list of release definitions to retrieve.
     * @param isDeleted - 'true' to get release definitions that has been deleted. Default is 'false'
     * @param searchTextContainsFolderName - 'true' to get the release definitions under the folder with name as specified in searchText. Default is 'false'.
     */
    getReleaseDefinitions(project: string, searchText?: string, expand?: Release.ReleaseDefinitionExpands, artifactType?: string, artifactSourceId?: string, top?: number, continuationToken?: string, queryOrder?: Release.ReleaseDefinitionQueryOrder, path?: string, isExactNameMatch?: boolean, tagFilter?: string[], propertyFilters?: string[], definitionIdFilter?: string[], isDeleted?: boolean, searchTextContainsFolderName?: boolean): Promise<VS_Services.PagedList<Release.ReleaseDefinition>>;
    /**
     * Gets the tags for a release
     * 
     * @param project - Project ID or project name
     * @param releaseId - 
     */
    getReleaseTags(project: string, releaseId: number): Promise<string[]>;
}

class ReleaseRestClient extends RestClientBase implements IReleaseRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get a release definition.
     * 
     * @param project - Project ID or project name
     * @param definitionId - Id of the release definition.
     * @param propertyFilters - A comma-delimited list of extended properties to be retrieved. If set, the returned Release Definition will contain values for the specified property Ids (if they exist). If not set, properties will not be included.
     */
    public async getReleaseDefinition(
        project: string,
        definitionId: number,
        propertyFilters?: string[]
        ): Promise<Release.ReleaseDefinition> {

        const queryValues: any = {
            propertyFilters: propertyFilters && propertyFilters.join(",")
        };

        return this.beginRequest<Release.ReleaseDefinition>({
            apiVersion: "4.1-preview.4",
            routeTemplate: "{project}/_apis/Release/definitions/{definitionId}",
            routeValues: {
                project: project,
                definitionId: definitionId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get a list of release definitions.
     * 
     * @param project - Project ID or project name
     * @param searchText - Get release definitions with names containing searchText.
     * @param expand - The properties that should be expanded in the list of Release definitions.
     * @param artifactType - Release definitions with given artifactType will be returned. Values can be Build, Jenkins, GitHub, Nuget, Team Build (external), ExternalTFSBuild, Git, TFVC, ExternalTfsXamlBuild.
     * @param artifactSourceId - Release definitions with given artifactSourceId will be returned. e.g. For build it would be \{projectGuid\}:\{BuildDefinitionId\}, for Jenkins it would be \{JenkinsConnectionId\}:\{JenkinsDefinitionId\}, for TfsOnPrem it would be \{TfsOnPremConnectionId\}:\{ProjectName\}:\{TfsOnPremDefinitionId\}. For third-party artifacts e.g. TeamCity, BitBucket you may refer 'uniqueSourceIdentifier' inside vss-extension.json at https://github.com/Microsoft/vsts-rm-extensions/blob/master/Extensions.
     * @param top - Number of release definitions to get.
     * @param continuationToken - Gets the release definitions after the continuation token provided.
     * @param queryOrder - Gets the results in the defined order. Default is 'IdAscending'.
     * @param path - Gets the release definitions under the specified path.
     * @param isExactNameMatch - 'true'to gets the release definitions with exact match as specified in searchText. Default is 'false'.
     * @param tagFilter - A comma-delimited list of tags. Only release definitions with these tags will be returned.
     * @param propertyFilters - A comma-delimited list of extended properties to be retrieved. If set, the returned Release Definitions will contain values for the specified property Ids (if they exist). If not set, properties will not be included. Note that this will not filter out any Release Definition from results irrespective of whether it has property set or not.
     * @param definitionIdFilter - A comma-delimited list of release definitions to retrieve.
     * @param isDeleted - 'true' to get release definitions that has been deleted. Default is 'false'
     * @param searchTextContainsFolderName - 'true' to get the release definitions under the folder with name as specified in searchText. Default is 'false'.
     */
    public async getReleaseDefinitions(
        project: string,
        searchText?: string,
        expand?: Release.ReleaseDefinitionExpands,
        artifactType?: string,
        artifactSourceId?: string,
        top?: number,
        continuationToken?: string,
        queryOrder?: Release.ReleaseDefinitionQueryOrder,
        path?: string,
        isExactNameMatch?: boolean,
        tagFilter?: string[],
        propertyFilters?: string[],
        definitionIdFilter?: string[],
        isDeleted?: boolean,
        searchTextContainsFolderName?: boolean
        ): Promise<VS_Services.PagedList<Release.ReleaseDefinition>> {

        const queryValues: any = {
            searchText: searchText,
            '$expand': expand,
            artifactType: artifactType,
            artifactSourceId: artifactSourceId,
            '$top': top,
            continuationToken: continuationToken,
            queryOrder: queryOrder,
            path: path,
            isExactNameMatch: isExactNameMatch,
            tagFilter: tagFilter && tagFilter.join(","),
            propertyFilters: propertyFilters && propertyFilters.join(","),
            definitionIdFilter: definitionIdFilter && definitionIdFilter.join(","),
            isDeleted: isDeleted,
            searchTextContainsFolderName: searchTextContainsFolderName
        };

        return this.beginRequest<Response>({
            apiVersion: "4.1-preview.4",
            routeTemplate: "{project}/_apis/Release/definitions/{definitionId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = <VS_Services.PagedList<Release.ReleaseDefinition>>await response.text().then(deserializeVssJsonObject);
            body.continuationToken = response.headers.get("x-ms-continuationtoken");
            return body;
        });
    }

    /**
     * Gets the tags for a release
     * 
     * @param project - Project ID or project name
     * @param releaseId - 
     */
    public async getReleaseTags(
        project: string,
        releaseId: number
        ): Promise<string[]> {

        return this.beginRequest<string[]>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "{project}/_apis/Release/releases/{releaseId}/tags/{*tag}",
            routeValues: {
                project: project,
                releaseId: releaseId
            }
        });
    }

}

export const ReleaseClientName = "Release_4.1.IReleaseRestClient";

export function getReleaseClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IReleaseRestClient {
    return pageContext.getRestClient<IReleaseRestClient>(ReleaseClientName, options);
}

RestClients.add(ReleaseClientName, { 
    factory: ReleaseRestClient,
    options: {
        resourceAreaId: "efc2f575-36ef-48e9-b672-0c6fb4a48ac5",
        serviceInstanceType: "0000000d-0000-8888-8000-000000000000"
    }
});
